import { Component } from '@angular/core';
import { CoreProvider } from './services/core.provider';
import { environment } from 'src/environments/environment';
@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public status: 'loading' | 'error' | 'ready' | 'auth_required' = 'ready';

  constructor(public readonly core: CoreProvider) {}

}
